var React = require('react');

function Modularity (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("polygon",{"className":"cls-1","points":"1.04 34.02 9.63 49.1 26.83 49.1 34.68 34.02 26.83 18.93 9.63 18.93 1.04 34.02","key":0}),React.createElement("polygon",{"className":"cls-1","points":"31.05 52.01 39.64 67.09 56.84 67.09 64.69 52.01 56.84 36.92 39.64 36.92 31.05 52.01","key":1}),React.createElement("polygon",{"className":"cls-1","points":"31.05 15.99 39.64 31.07 56.84 31.07 64.69 15.99 56.84 .9 39.64 .9 31.05 15.99","key":2})])]);
}

Modularity.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 65.7 67.99"};

module.exports = Modularity;

Modularity.default = Modularity;
